module.exports = "//static.hsappstatic.net/ecosystem-marketplace-core/static-1.4178/img/callout-wave.svg"